import { gql } from '@apollo/client'

export const ATTACHMENT_ATTRIBUTES = gql`
  fragment attachmentAttributes on Attachment {
    id
    createdAt
    updatedAt

    fileName
    fileSize
    contentType
    description
    metadata
    type

    key
    url
  }
`
export const ATTACHMENT_ATTRIBUTES_ENTITY = gql`
  fragment attachmentEntityAttributes on AttachmentEntity {
    id
    key
    url
  }
`

const ATTACHMENT_UPLOAD_URL_ATTRIBUTES = gql`
  fragment attachmentUploadUrlAttributes on AttachmentUploadUrl {
    uploadUrl
    key
    url

    fileName
    fileSize
    contentType

    type
  }
`

export const CREATE_ATTACHMENT_UPLOAD_URL = gql`
  mutation createAttachmentUploadUrl_UI(
    $input: CreateAttachmentUploadUrlInput!
  ) {
    createAttachmentUploadUrl(input: $input) {
      ...attachmentUploadUrlAttributes
    }
  }
  ${ATTACHMENT_UPLOAD_URL_ATTRIBUTES}
`

export const CREATE_ATTACHMENT = gql`
  mutation createAttachment_UI($input: CreateAttachmentInput!) {
    createAttachment(input: $input) {
      ...attachmentAttributes
    }
  }
  ${ATTACHMENT_ATTRIBUTES}
`

export const CREATE_MULTIPLE_ATTACHMENTS = gql`
  mutation createMultipleAttachments_UI($input: [CreateAttachmentInput!]) {
    createMultipleAttachments(input: $input) {
      ...attachmentAttributes
    }
  }
  ${ATTACHMENT_ATTRIBUTES}
`

export const ARCHIVE_ATTACHMENT = gql`
  mutation archiveAttachment_UI($id: String!) {
    archiveAttachment(id: $id) {
      ...attachmentAttributes
    }
  }
  ${ATTACHMENT_ATTRIBUTES}
`

export const CREATE_PUBLIC_ATTACHMENT = gql`
  mutation createPublicAttachment_UI($input: CreateAttachmentInput!) {
    createPublicAttachment(input: $input) {
      ...attachmentEntityAttributes
    }
  }
  ${ATTACHMENT_ATTRIBUTES_ENTITY}
`

export const GET_ATTACHMENT_URL = gql`
  query getAttachmentUrl_UI($key: String!) {
    getAttachmentUrl(key: $key) {
      key
      url
    }
  }
`

export const CREATE_ZIP_ATTACHMENTS_URL = gql`
  mutation createZipAttachmentsUrl_UI($input: CreateZipAttachmentsUrlInput!) {
    createZipAttachmentsUrl(input: $input) {
      url
    }
  }
`

export const UPDATE_ATTACHMENT_INFO = gql`
  mutation updateAttachmentInfo_UI(
    $id: String!
    $input: UpdateAttachmentInfoInput!
  ) {
    updateAttachmentInfo(id: $id, input: $input) {
      ...attachmentAttributes
    }
  }
  ${ATTACHMENT_ATTRIBUTES}
`
